const { ToggleControl } = wp.components;

const CarLoop = props => {
	
	const { attributes, setAttributes } = props;
	
	return (
		<p>
			<ToggleControl
			    label={ "Enable Infinite Carousel" }
			    checked={ attributes.loop }
			    onChange={ (loopVal) => setAttributes({loop: loopVal} ) }
			/>
		</p>
	)
}

export default CarLoop;